module.exports = __webpack_public_path__ + "static/img/2.6a5c05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/2.png
// module id = hfpJ
// module chunks = 0